document.addEventListener("DOMContentLoaded", function () {
  function handleMobileFooter() {
    const footerDetails = document.querySelectorAll(
      ".footer-block__details-content"
    );
    const footerHeadings = document.querySelectorAll(".footer-block__heading");

    if (window.innerWidth <= 749) {
      footerDetails.forEach((detail) => {
        detail.style.display = "none";
      });

      footerHeadings.forEach((heading) => {
        heading.removeEventListener("click", toggleAccordion);

        heading.style.cursor = "pointer";
        heading.addEventListener("click", toggleAccordion);
      });
    } else {
      footerDetails.forEach((detail) => {
        detail.style.display = "block";
      });

      footerHeadings.forEach((heading) => {
        heading.style.cursor = "default";
        heading.removeEventListener("click", toggleAccordion);
      });
    }
  }

  function toggleAccordion() {
    const content = this.nextElementSibling;
    if (content.classList.contains("footer-block__details-content")) {
      if (content.style.display === "none" || content.style.display === "") {
        content.style.display = "block";
      } else {
        content.style.display = "none";
      }
    }
  }

  handleMobileFooter();

  let resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(handleMobileFooter, 250);
  });
});

document.addEventListener("DOMContentLoaded", function () {
  var offcanvasMenu = document.querySelector(".offcanvas-menu");

  document.querySelectorAll(".menu-click").forEach(function (element) {
    element.addEventListener("click", function (event) {
      event.stopPropagation(); // Stop propagation to prevent the body click event from triggering
      offcanvasMenu.classList.toggle("open");
      toggleBodyOverflow();
    });
  });

  document.body.addEventListener("swipeleft", function () {
    offcanvasMenu.classList.add("open");
    toggleBodyOverflow();
  });

  document
    .querySelector(".offcanvas-menu")
    .addEventListener("swiperight", function () {
      offcanvasMenu.classList.toggle("open");
      toggleBodyOverflow();
    });

  document.body.addEventListener("click", function (event) {
    const offcanvasMenus = document.querySelectorAll(".offcanvas-menu");

    offcanvasMenus.forEach((offcanvasMenu) => {
      if (
        !offcanvasMenu.contains(event.target) &&
        !event.target.closest(".offcanvas-menu")
      ) {
        if (!offcanvasMenu.classList.contains("open")) {
          return;
        }

        offcanvasMenu.classList.remove("open");
        toggleBodyOverflow();
      }
    });
  });

  function toggleBodyOverflow() {
    document.body.classList.toggle("overflow-hidden");
  }
});


// Product Option JS

document.addEventListener('DOMContentLoaded', function () {

  /* ============================================================
     AAA DISTRIBUTOR - COMPLETE ASSEMBLY FEE SYSTEM
     ============================================================

     CABINET DETECTION PRIORITY

     1. Product TAG
        base_cabinet
        wall_cabinet
        tall_cabinet

     2. Product Type

     3. Product Handle

     4. Product Title

     ASSEMBLY OPTIONS

     rta
     assembled
     rush

     IMPORTANT:
     This script does NOT automatically reload the page.
     After fee changes, Dawn cart sections are refreshed instead.
     ============================================================ */


  /* ============================================================
     ASSEMBLY FEE VARIANT IDS
     ============================================================ */

  const WALL_FEE = 52570685669688;
  const BASE_FEE = 52570685112632;
  const TALL_FEE = 52570700939576;

  const RUSH_WALL_FEE = 52570712277304;
  const RUSH_BASE_FEE = 52570711916856;
  const RUSH_TALL_FEE = 52570712506680;

  const RUSH_FEE = 52570708279608;


  /* ============================================================
     ALL FEE PRODUCTS
     ============================================================ */

  const FEE_PRODUCTS = [
    WALL_FEE,
    BASE_FEE,
    TALL_FEE,
    RUSH_WALL_FEE,
    RUSH_BASE_FEE,
    RUSH_TALL_FEE,
    RUSH_FEE
  ];


  /* ============================================================
     CABINET TAGS
     ============================================================ */

  const CABINET_TAGS = {
    base: 'base_cabinet',
    wall: 'wall_cabinet',
    tall: 'tall_cabinet'
  };


  /* ============================================================
     PAGE HELPERS
     ============================================================ */

  function isCartPage() {
    return (
      window.location.pathname === '/cart' ||
      window.location.pathname.startsWith('/cart') ||
      Boolean(document.getElementById('cabinetAssembly'))
    );
  }


  /* ============================================================
     STATE
     ============================================================ */

  let syncRunning = false;
  let syncTimer = null;
  let internalUpdate = false;
  let cartRenderRunning = false;

  const productCache = {};


  /* ============================================================
     GET CART
     ============================================================ */

  async function getCart() {

    try {

      const response = await fetch('/cart.js', {
        method: 'GET',
        credentials: 'same-origin',
        cache: 'no-store'
      });

      if (!response.ok) {
        throw new Error('Cart request failed');
      }

      return await response.json();

    } catch (error) {

      console.error(
        '[AAA Assembly] Unable to get cart:',
        error
      );

      return null;

    }

  }


  /* ============================================================
     GET PRODUCT DATA
     ============================================================ */

  async function getProductData(handle) {

    if (!handle) {
      return null;
    }

    if (productCache[handle]) {
      return productCache[handle];
    }

    try {

      const response = await fetch(
        '/products/' +
        encodeURIComponent(handle) +
        '.js',
        {
          method: 'GET',
          credentials: 'same-origin',
          cache: 'force-cache'
        }
      );

      if (!response.ok) {

        console.warn(
          '[AAA Assembly] Product JSON failed:',
          handle
        );

        return null;

      }

      const product = await response.json();

      productCache[handle] = product;

      return product;

    } catch (error) {

      console.warn(
        '[AAA Assembly] Product data unavailable:',
        handle,
        error
      );

      return null;

    }

  }


  /* ============================================================
     GET PRODUCT TAGS
     ============================================================ */

  async function getProductTags(item) {

    if (!item) {
      return [];
    }


    /*
    Some custom cart implementations may
    already provide tags.
    */

    if (Array.isArray(item.tags)) {

      return item.tags.map(function (tag) {

        return String(tag)
          .trim()
          .toLowerCase();

      });

    }


    const handle =
      String(
        item.handle || ''
      ).trim();


    if (!handle) {
      return [];
    }


    const product =
      await getProductData(handle);


    if (
      product &&
      Array.isArray(product.tags)
    ) {

      return product.tags.map(function (tag) {

        return String(tag)
          .trim()
          .toLowerCase();

      });

    }


    return [];

  }


  /* ============================================================
     GET CABINET TYPE
     ============================================================ */

  async function getCabinetType(item) {

    if (!item) {
      return null;
    }


    const variantId =
      Number(item.variant_id);


    /*
    Never treat assembly fee products
    as cabinet products.
    */

    if (
      FEE_PRODUCTS.includes(variantId)
    ) {

      return null;

    }


    /* ==========================================================
       1. TAG BASED DETECTION
       ========================================================== */

    const tags =
      await getProductTags(item);


    /*
    TALL TAG
    */

    if (
      tags.includes(
        CABINET_TAGS.tall
      )
    ) {

      console.log(
        '[AAA Assembly] TAG → TALL:',
        item.title
      );

      return 'tall';

    }


    /*
    WALL TAG
    */

    if (
      tags.includes(
        CABINET_TAGS.wall
      )
    ) {

      console.log(
        '[AAA Assembly] TAG → WALL:',
        item.title
      );

      return 'wall';

    }


    /*
    BASE TAG
    */

    if (
      tags.includes(
        CABINET_TAGS.base
      )
    ) {

      console.log(
        '[AAA Assembly] TAG → BASE:',
        item.title
      );

      return 'base';

    }


    /* ==========================================================
       2. FALLBACK
       ========================================================== */

    const productType =
      String(
        item.product_type || ''
      ).toLowerCase();


    const handle =
      String(
        item.handle || ''
      ).toLowerCase();


    const title =
      String(
        item.title || ''
      ).toLowerCase();


    /* ==========================================================
       TALL
       ========================================================== */

    if (

      productType.includes('tall') ||
      handle.includes('tall') ||
      title.includes('tall') ||

      handle.includes('utility') ||
      title.includes('utility') ||

      handle.includes('oven') ||
      title.includes('oven')

    ) {

      console.log(
        '[AAA Assembly] FALLBACK → TALL:',
        item.title
      );

      return 'tall';

    }


    /* ==========================================================
       WALL
       ========================================================== */

    if (

      productType.includes('wall') ||
      handle.includes('wall') ||
      title.includes('wall') ||

      handle.includes('diagonal') ||
      title.includes('diagonal')

    ) {

      console.log(
        '[AAA Assembly] FALLBACK → WALL:',
        item.title
      );

      return 'wall';

    }


    /* ==========================================================
       BASE
       ========================================================== */

    if (

      productType.includes('base') ||
      handle.includes('base') ||
      title.includes('base') ||

      handle.includes('vanity') ||
      title.includes('vanity')

    ) {

      console.log(
        '[AAA Assembly] FALLBACK → BASE:',
        item.title
      );

      return 'base';

    }


    return null;

  }


  /* ============================================================
     GET ASSEMBLY TYPE
     ============================================================ */

  function getAssemblyType(cart) {

    // When outside the cart page, never assume 'rush' or 'assembled'
    if (!isCartPage()) {
      return 'rta';
    }

    if (

      cart &&
      cart.attributes &&
      cart.attributes['Cabinet Assembly']

    ) {

      return String(
        cart.attributes['Cabinet Assembly']
      ).toLowerCase();

    }

    return 'rta';

  }


  /* ============================================================
     UPDATE ASSEMBLY ATTRIBUTE
     ============================================================ */

  async function updateAssemblyAttribute(value) {

    internalUpdate = true;

    try {

      const response =
        await fetch(
          '/cart/update.js',
          {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type':
                'application/json'
            },
            body: JSON.stringify({

              attributes: {
                'Cabinet Assembly':
                  value
              }

            })
          }
        );


      if (!response.ok) {

        throw new Error(
          'Assembly attribute update failed'
        );

      }


      return await response.json();

    } finally {

      internalUpdate = false;

    }

  }


  /* ============================================================
     DEFAULT RTA
     ============================================================ */

  async function setDefaultAssembly() {

    const cart =
      await getCart();


    if (!cart) {
      return;
    }


    const currentAssembly =
      cart.attributes &&
      cart.attributes['Cabinet Assembly'];


    /*
    Never overwrite an existing selection.
    */

    if (currentAssembly) {
      return;
    }


    let hasCabinet = false;


    for (
      const item of cart.items
    ) {

      const type =
        await getCabinetType(item);


      if (type) {

        hasCabinet = true;

        break;

      }

    }


    if (!hasCabinet) {
      return;
    }


    await updateAssemblyAttribute(
      'rta'
    );

  }


  /* ============================================================
     CALCULATE REQUIRED FEES
     ============================================================ */

  async function calculateRequiredFees(
    cart,
    assembly
  ) {

    const requiredFees = {

      [WALL_FEE]: 0,
      [BASE_FEE]: 0,
      [TALL_FEE]: 0,

      [RUSH_WALL_FEE]: 0,
      [RUSH_BASE_FEE]: 0,
      [RUSH_TALL_FEE]: 0,

      [RUSH_FEE]: 0

    };


    /*
    RTA = no assembly fees.
    */

    if (
      assembly === 'rta'
    ) {

      return requiredFees;

    }


    let wallQuantity = 0;
    let baseQuantity = 0;
    let tallQuantity = 0;


    /*
    Check every cart item.
    */

    for (
      const item of cart.items
    ) {

      const cabinetType =
        await getCabinetType(item);


      if (!cabinetType) {
        continue;
      }


      const quantity =
        Number(item.quantity) || 0;


      if (
        cabinetType === 'wall'
      ) {

        wallQuantity += quantity;

      }


      if (
        cabinetType === 'base'
      ) {

        baseQuantity += quantity;

      }


      if (
        cabinetType === 'tall'
      ) {

        tallQuantity += quantity;

      }

    }


    console.log(
      '[AAA Assembly] Cabinet quantities:',
      {
        base: baseQuantity,
        wall: wallQuantity,
        tall: tallQuantity
      }
    );


    /* ==========================================================
       ASSEMBLED
       ========================================================== */

    if (
      assembly === 'assembled'
    ) {

      requiredFees[WALL_FEE] =
        wallQuantity;

      requiredFees[BASE_FEE] =
        baseQuantity;

      requiredFees[TALL_FEE] =
        tallQuantity;

    }


    /* ==========================================================
       RUSH ASSEMBLED
       ========================================================== */

    if (
      assembly === 'rush'
    ) {

      requiredFees[RUSH_WALL_FEE] =
        wallQuantity;

      requiredFees[RUSH_BASE_FEE] =
        baseQuantity;

      requiredFees[RUSH_TALL_FEE] =
        tallQuantity;


      if (

        wallQuantity > 0 ||
        baseQuantity > 0 ||
        tallQuantity > 0

      ) {

        requiredFees[RUSH_FEE] =
          1;

      }

    }


    return requiredFees;

  }


  /* ============================================================
     GET CURRENT FEE QUANTITIES
     ============================================================ */

  function getCurrentFeeQuantities(cart) {

    const currentFees = {};


    FEE_PRODUCTS.forEach(function (id) {

      currentFees[id] = 0;

    });


    cart.items.forEach(function (item) {

      const variantId =
        Number(item.variant_id);


      if (
        FEE_PRODUCTS.includes(
          variantId
        )
      ) {

        currentFees[variantId] +=
          Number(item.quantity) || 0;

      }

    });


    return currentFees;

  }


  /* ============================================================
     CHECK FEE STATE
     ============================================================ */

  function feeStateNeedsUpdate(
    cart,
    requiredFees
  ) {

    const currentFees =
      getCurrentFeeQuantities(
        cart
      );


    for (
      const variantId of FEE_PRODUCTS
    ) {

      const current =
        currentFees[variantId] || 0;


      const required =
        requiredFees[variantId] || 0;


      if (
        current !== required
      ) {

        return true;

      }

    }


    return false;

  }


  /* ============================================================
     UPDATE EXISTING FEE PRODUCTS
     ============================================================ */

  async function updateExistingFees(
    cart,
    requiredFees
  ) {

    const updates = {};

    /*
    Track which fee variant has already
    received its required quantity.

    This also protects against duplicate
    fee lines.
    */

    const processedVariants = new Set();


    cart.items.forEach(function (item) {

      const variantId =
        Number(item.variant_id);


      if (
        !FEE_PRODUCTS.includes(
          variantId
        )
      ) {

        return;

      }


      const requiredQuantity =
        Number(
          requiredFees[variantId] || 0
        );


      const currentQuantity =
        Number(item.quantity) || 0;


      /*
      First occurrence receives
      the required quantity.

      Any duplicate line is removed.
      */

      let targetQuantity = 0;


      if (
        !processedVariants.has(
          variantId
        )
      ) {

        targetQuantity =
          requiredQuantity;

        processedVariants.add(
          variantId
        );

      }


      if (
        currentQuantity !==
        targetQuantity
      ) {

        updates[item.key] =
          targetQuantity;

      }

    });


    if (
      Object.keys(updates).length === 0
    ) {

      return false;

    }


    console.log(
      '[AAA Assembly] Updating existing fees:',
      updates
    );


    internalUpdate = true;


    try {

      const response =
        await fetch(
          '/cart/update.js',
          {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type':
                'application/json'
            },
            body: JSON.stringify({

              updates:
                updates

            })
          }
        );


      if (!response.ok) {

        throw new Error(
          'Fee update failed'
        );

      }


      await response.json();


      return true;

    } finally {

      internalUpdate = false;

    }

  }


  /* ============================================================
     ADD MISSING FEE PRODUCTS
     ============================================================ */

  async function addMissingFees(
    cart,
    requiredFees
  ) {

    const existingFeeVariants =
      new Set();


    cart.items.forEach(function (item) {

      const variantId =
        Number(item.variant_id);


      if (
        FEE_PRODUCTS.includes(
          variantId
        ) &&
        Number(item.quantity) > 0
      ) {

        existingFeeVariants.add(
          variantId
        );

      }

    });


    const itemsToAdd = [];


    Object.keys(
      requiredFees
    ).forEach(function (id) {

      const variantId =
        Number(id);


      const requiredQuantity =
        Number(
          requiredFees[variantId] || 0
        );


      if (

        requiredQuantity > 0 &&
        !existingFeeVariants.has(
          variantId
        )

      ) {

        itemsToAdd.push({

          id:
            variantId,

          quantity:
            requiredQuantity

        });

      }

    });


    if (
      itemsToAdd.length === 0
    ) {

      return false;

    }


    console.log(
      '[AAA Assembly] Adding missing fees:',
      itemsToAdd
    );


    internalUpdate = true;


    try {

      const response =
        await fetch(
          '/cart/add.js',
          {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type':
                'application/json'
            },
            body: JSON.stringify({

              items:
                itemsToAdd

            })
          }
        );


      if (!response.ok) {

        throw new Error(
          'Fee add failed'
        );

      }


      await response.json();


      return true;

    } finally {

      internalUpdate = false;

    }

  }


  /* ============================================================
     RENDER DAWN CART UI
     ============================================================

     THIS IS THE IMPORTANT FIX.

     Shopify cart.js can contain the correct products while
     the visible Dawn cart HTML still contains old data.

     We request the latest Dawn sections and replace them
     without refreshing the entire page.
     ============================================================ */


  async function renderCartUI() {

    if (cartRenderRunning) {
      return;
    }

    cartRenderRunning = true;

    try {

      console.log(
        '[AAA Assembly] Assembly fees updated - refreshing cart page'
      );

      /*
      IMPORTANT:
      Do not manually replace Dawn sections here.

      Your existing fee synchronization has already completed
      before this function is called.

      Reload the current cart page so:
      - Wall Assembly Fee
      - Base Assembly Fee
      - Tall Assembly Fee
      - Rush Assembly Fees
      - Cart totals
      - RTA / Assembled / Rush UI
      - DS pickup locations

      are all rebuilt from the latest Shopify cart state.
      */

      await new Promise(function (resolve) {

        requestAnimationFrame(function () {
          resolve();
        });

      });


      /*
      Reload ONLY after Shopify has finished the fee update.
      The customer does not need to manually refresh.
      */

      window.location.reload();


    } catch (error) {

      console.error(
        '[AAA Assembly] Cart refresh failed:',
        error
      );

      /*
      Fallback
      */

      window.location.href = '/cart';

    }

  }

  /* ============================================================
     MAIN ASSEMBLY FEE SYNC
     ============================================================ */

  async function syncAssemblyFees() {

    // Strictly ensure sync only runs if on the cart page
    if (!isCartPage()) {
      return;
    }

    /*
    Prevent overlapping sync operations.
    */

    if (syncRunning) {
      return;
    }


    syncRunning = true;


    let feesChanged = false;


    try {

      let cart =
        await getCart();


      if (!cart) {
        return;
      }


      const assembly =
        getAssemblyType(cart);


      const requiredFees =
        await calculateRequiredFees(
          cart,
          assembly
        );


      console.log(
        '[AAA Assembly] Sync:',
        assembly,
        requiredFees
      );


      /*
      ==========================================================
      CHECK CURRENT FEE STATE
      ==========================================================
      */

      const needsUpdate =
        feeStateNeedsUpdate(
          cart,
          requiredFees
        );


      if (!needsUpdate) {

        console.log(
          '[AAA Assembly] Fees already correct'
        );

        return;

      }


      /*
      ==========================================================
      UPDATE EXISTING FEES
      ==========================================================
      */

      const existingUpdated =
        await updateExistingFees(
          cart,
          requiredFees
        );


      if (existingUpdated) {
        feesChanged = true;
      }


      /*
      ==========================================================
      GET LATEST CART
      ==========================================================
      */

      cart =
        await getCart();


      if (!cart) {
        return;
      }


      /*
      ==========================================================
      ADD MISSING FEES
      ==========================================================
      */

      const missingAdded =
        await addMissingFees(
          cart,
          requiredFees
        );


      if (missingAdded) {
        feesChanged = true;
      }


      /*
      ==========================================================
      FINAL CART
      ==========================================================
      */

      const finalCart =
        await getCart();


      if (!finalCart) {
        return;
      }


      console.log(
        '[AAA Assembly] Final cart:',
        finalCart.items
      );


      /*
      ==========================================================
      REFRESH ONLY THE CART HTML
      ==========================================================

      NO:

          window.location.href
          window.location.reload()
          setTimeout reload

      Only Dawn sections are refreshed.
      */

      if (feesChanged) {

        await renderCartUI();

      }

    } catch (error) {

      console.error(
        '[AAA Assembly] Sync error:',
        error
      );

    } finally {

      syncRunning = false;

    }

  }


  /* ============================================================
     SCHEDULE CART SYNC
     ============================================================ */

  function scheduleCartSync(
    delay = 900
  ) {

    clearTimeout(
      syncTimer
    );


    syncTimer =
      setTimeout(function () {

        syncAssemblyFees();

      }, delay);

  }


  /* ============================================================
     ASSEMBLY DROPDOWN
     ============================================================ */

  document.addEventListener(
    'change',
    async function (event) {

      const select =
        event.target.closest(
          '#cabinetAssembly'
        );


      if (!select) {
        return;
      }


      const value =
        select.value || 'rta';


      console.log(
        '[AAA Assembly] Assembly changed:',
        value
      );


      try {

        /*
        Save assembly option.
        */

        await updateAssemblyAttribute(
          value
        );


        /*
        Recalculate fees.
        */

        await syncAssemblyFees();


        /*
        Re-render the cart after
        assembly selection.
        */

        await renderCartUI();


      } catch (error) {

        console.error(
          '[AAA Assembly] Assembly selection error:',
          error
        );

      }

    }
  );


  /* ============================================================
     INTERCEPT SHOPIFY CART REQUESTS
     ============================================================ */

  const originalFetch =
    window.fetch;


  window.fetch =
    async function () {

      const args =
        arguments;


      const request =
        args[0];


      let url = '';


      if (
        typeof request === 'string'
      ) {

        url =
          request;

      }

      else if (
        request &&
        request.url
      ) {

        url =
          request.url;

      }


      /*
      Execute original Shopify request.
      */

      const response =
        await originalFetch.apply(
          this,
          args
        );


      /*
      Never react to our own fee requests.
      Only trigger sync if currently on the cart page AND 
      the action is a cart modification (excluding /cart/add).
      */

      if (
        !internalUpdate &&
        isCartPage()
      ) {

        const isCartOperation =

          url.includes(
            '/cart/change'
          ) ||

          url.includes(
            '/cart/update'
          ) ||

          url.includes(
            '/cart/clear'
          );


        if (
          isCartOperation
        ) {

          console.log(
            '[AAA Assembly] Cart operation detected:',
            url
          );


          /*
          Give Dawn time to complete
          its own cart operation.
          */

          scheduleCartSync(
            1000
          );

        }

      }


      return response;

    };


  /* ============================================================
     CART EVENTS
     ============================================================ */

  const cartEvents = [

    'cart:updated',
    'cart:change',
    'cart:refresh',
    'cart-updated',
    'cart:rendered'

  ];


  cartEvents.forEach(function (eventName) {

    document.addEventListener(
      eventName,
      function () {

        /*
        Ignore events generated by
        our own internal rendering.
        Only sync on cart page.
        */

        if (
          !internalUpdate &&
          !cartRenderRunning &&
          isCartPage()
        ) {

          scheduleCartSync(
            800
          );

        }

      }
    );

  });


  /* ============================================================
     QUANTITY INPUT
     ============================================================ */

  document.addEventListener(
    'change',
    function (event) {

      const input =
        event.target;


      if (
        input.matches(
          'input[name="updates[]"]'
        )
      ) {

        console.log(
          '[AAA Assembly] Quantity input changed'
        );


        scheduleCartSync(
          1000
        );

      }

    }
  );


  /* ============================================================
     REMOVE BUTTON
     ============================================================ */

  document.addEventListener(
    'click',
    function (event) {

      const removeButton =
        event.target.closest(
          'cart-remove-button a, ' +
          '.cart-remove-button, ' +
          'a[href*="/cart/change"]'
        );


      if (!removeButton) {
        return;
      }


      console.log(
        '[AAA Assembly] Remove clicked'
      );


      /*
      Dawn handles the actual removal.

      The fetch interceptor catches
      /cart/change and synchronizes
      assembly fees afterwards.
      */

    }
  );


  /* ============================================================
     PLUS / MINUS
     ============================================================ */

  document.addEventListener(
    'click',
    function (event) {

      const button =
        event.target.closest(
          'button[name="plus"], ' +
          'button[name="minus"]'
        );


      if (!button) {
        return;
      }


      console.log(
        '[AAA Assembly] Quantity button clicked'
      );


      /*
      Dawn handles the quantity change.

      Fetch interceptor handles synchronization.
      */

    }
  );


  /* ============================================================
     INITIALIZATION
     ============================================================ */

  async function initializeAssembly() {

    if (!isCartPage()) {
      return;
    }

    /*
    Set RTA only if there is no
    saved assembly selection.
    */

    await setDefaultAssembly();


    /*
    Initial synchronization.

    IMPORTANT:
    No page reload.
    */

    await syncAssemblyFees();

  }


  initializeAssembly();


  /* ============================================================
     DS LOCATION SYSTEM
     ============================================================ */

  async function getAssemblyTypeForLocation() {

    const cart =
      await getCart();


    if (

      cart &&
      cart.attributes &&
      cart.attributes['Cabinet Assembly']

    ) {

      return String(
        cart.attributes['Cabinet Assembly']
      ).toLowerCase();

    }


    return 'rta';

  }


  /* ============================================================
     LOCATION HELPERS
     ============================================================ */

  function getLocation(id) {

    const radio =
      document.getElementById(
        id
      );


    if (!radio) {
      return null;
    }


    return radio.closest(
      '.location'
    );

  }


  function showLocation(location) {

    if (!location) {
      return;
    }


    location.style.setProperty(
      'display',
      'block',
      'important'
    );

  }


  function hideLocation(location) {

    if (!location) {
      return;
    }


    location.style.setProperty(
      'display',
      'none',
      'important'
    );

  }


  function triggerLocationSelection(radio) {

    if (!radio) {
      return;
    }


    try {

      if (
        !radio.checked
      ) {

        radio.checked =
          true;


        radio.dispatchEvent(
          new Event(
            'change',
            {
              bubbles: true
            }
          )
        );

      }


      radio.dispatchEvent(
        new MouseEvent(
          'click',
          {
            bubbles: true,
            cancelable: true
          }
        )
      );

    } catch (error) {

      console.warn(
        '[AAA Assembly] Location selection error:',
        error
      );

    }

  }


  /* ============================================================
     UPDATE DS LOCATIONS
     ============================================================ */

  async function updateLocations() {

    const assembly =
      await getAssemblyTypeForLocation();


    const radio4888 =
      document.getElementById(
        'location_4888'
      );


    const radio4889 =
      document.getElementById(
        'location_4889'
      );


    const radio4876 =
      document.getElementById(
        'location_4876'
      );


    const location4888 =
      radio4888?.closest(
        '.location'
      );


    const location4889 =
      radio4889?.closest(
        '.location'
      );


    const location4876 =
      radio4876?.closest(
        '.location'
      );


    /* ==========================================================
       RTA
       ========================================================== */

    if (
      assembly === 'rta'
    ) {

      hideLocation(
        location4888
      );


      if (location4889) {

        showLocation(
          location4889
        );

      }

      else if (location4876) {

        showLocation(
          location4876
        );

      }


      return;

    }


    /* ==========================================================
       RUSH
       ========================================================== */

    if (
      assembly === 'rush'
    ) {

      showLocation(
        location4888
      );


      hideLocation(
        location4889
      );


      hideLocation(
        location4876
      );


      if (
        radio4888 &&
        !radio4888.checked
      ) {

        triggerLocationSelection(
          radio4888
        );

      }


      return;

    }


    /* ==========================================================
       ASSEMBLED
       ========================================================== */

    if (
      assembly === 'assembled'
    ) {

      hideLocation(
        location4888
      );


      showLocation(
        location4889
      );


      showLocation(
        location4876
      );

    }

  }


  /* ============================================================
     DS INITIAL LOAD
     ============================================================ */

  let locationAttempts = 0;


  const locationLoader =
    setInterval(function () {

      const exists =

        document.getElementById(
          'location_4888'
        ) ||

        document.getElementById(
          'location_4889'
        ) ||

        document.getElementById(
          'location_4876'
        );


      if (exists) {

        updateLocations();

      }


      locationAttempts++;


      if (
        locationAttempts >= 60
      ) {

        clearInterval(
          locationLoader
        );

      }

    }, 500);


  /* ============================================================
     DS MUTATION OBSERVER
     ============================================================ */

  let observerTimer =
    null;


  const observer =
    new MutationObserver(function () {

      clearTimeout(
        observerTimer
      );


      observerTimer =
        setTimeout(function () {

          updateLocations();

        }, 150);

    });


  if (document.body) {

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );

  }


  /* ============================================================
     DS BACKUP
     ============================================================ */

  setInterval(function () {

    updateLocations();

  }, 1500);

});